import {CanActivateFn} from "@angular/router";
import {inject} from "@angular/core";
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service"; // Using ngx-cookie-service for cookie management
import {Userrole} from "../../shared/interfaces/user";

export const checkWorkplaceGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  // Check if the user is "Mitarbeiter"
  if (userService.userrole() === Userrole.Mitarbeiter) {
    const hasWorkplace = cookieService.check("workplace");
    const hasProductionLine = cookieService.check("productionLine");

    // Redirect to selectWorkplaceComponent if cookies are missing
    if (!hasWorkplace || !hasProductionLine) {
      router.navigate(["/select"]);
      return false;
    }
  }

  // Allow access otherwise
  return true;
};
